import { render, staticRenderFns } from "./GenericButton.vue?vue&type=template&id=2dfea390&scoped=true&"
import script from "./GenericButton.vue?vue&type=script&lang=ts&"
export * from "./GenericButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfea390",
  null
  
)

export default component.exports